(() => {
  'use strict';
  if (!customElements.get('park-gallery-progress')) {
    class ParkGalleryProgress extends HTMLElement {
      connectedCallback() {
        if (this.updateProgress) return;
        const track = this.querySelector('[data-gallery-track]');
        const bar = this.querySelector('[data-gallery-bar]');
        if (!track || !bar) return;
        this.updateProgress = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          bar.parentElement.style.display = maximum <= 1 ? 'none' : '';
          if (maximum <= 1) return;
          const width = Math.max(track.clientWidth / track.scrollWidth * 100, 12);
          const progress = Math.max(0, Math.min(1, track.scrollLeft / maximum));
          bar.style.width = `${width}%`;
          bar.style.transform = `translateX(${progress * (100 - width) / width * 100}%)`;
        };
        this.track = track;
        track.addEventListener('scroll', this.updateProgress, {passive: true});
        window.addEventListener('resize', this.updateProgress);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.updateProgress);
          this.observer.observe(track);
        }
        this.updateProgress();
      }
      disconnectedCallback() {
        if (!this.updateProgress) return;
        this.track.removeEventListener('scroll', this.updateProgress);
        window.removeEventListener('resize', this.updateProgress);
        this.observer?.disconnect();
        this.updateProgress = null;
      }
    }
    customElements.define('park-gallery-progress', ParkGalleryProgress);
  }
  if (window.parkGalleryRevealRegistered) return;
  window.parkGalleryRevealRegistered = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-park-gallery-reveal]');
    if (!button) return;
    const teaser = button.closest('[data-lp-teaser]');
    const targets = document.querySelectorAll('[data-lp-group="collapsible"]');
    if (teaser) teaser.style.display = 'none';
    targets.forEach(target => target.classList.remove('lp-hidden'));
    // Existing LP/native carousels remeasure after their formerly hidden parent is visible.
    window.dispatchEvent(new Event('resize'));
    if (targets.length) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      targets[0].scrollIntoView({behavior: reducedMotion ? 'auto' : 'smooth', block: 'start'});
    }
  });
})();
